import React, { PureComponent, PropTypes } from 'react';
import { hashHistory } from 'react-router';
import { injectIntl } from 'react-intl';
import cn from 'classnames';
import { Button, Card, Input, Progressbar } from '../../shared';
import statsd from '../../../lib/StatsD';
import './styles.scss';
import messages from './i18n';

export class Authenticate extends PureComponent {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.state = {
      username: '',
      password: '',
      emailLogin: false,
      sending: false,
    };
  }

  getPasswordField() {
    if (this.state.emailLogin) {
      return [
        <Input
          key={1}
          className='AuthForm__input'
          name={this.props.intl.formatMessage(messages.password)}
          type='password'
          value={this.state.password || ''}
          onChange={event => this.setState({ password: event.target.value })}
        />,
        <div className="AuthForm__forgot" key={2}>
          <a
            className="AuthForm__link"
            href={`${__BASE_URL__}/users/password/new`}
          >
            Forgot your password?
          </a>
        </div>,
      ];
    }
    return null;
  }

  getButtonClass() {
    return this.state.sending ? 'fa-circle-o-notch fa-spin' : 'fa-arrow-right';
  }

  toggleEmailLogin(e) {
    e.preventDefault();
    this.setState({
      emailLogin: !this.state.emailLogin,
    });
  }

  async submitForm(event) {
    event.preventDefault();
    if (this.state.sending) {
      return; // short circuit so we don't post again.
    }
    this.setState({ sending: true });
    const res = await this.props.authAccount(this.state.username, this.state.password);
    if (res) {
      this.props.next();
    } else {
      this.setState({ sending: false });
    }
  }

  render() {
    return (
      <div className='Auth'>
        <Card>
          <Progressbar />
          <form className='AuthForm' onSubmit={event => this.submitForm(event)}>
            <Input
              className='AuthForm__input'
              name={this.props.intl.formatMessage(this.state.emailLogin ? messages.email :
                                                    messages.setupCodeNoLength)}
              type='text'
              value={this.state.username}
              onChange={event => this.setState({ username: event.target.value })}
            />
            {this.getPasswordField()}

            <div className="divider">
              <hr />
              <span>OR</span>
              <hr />
            </div>

            <div className="AuthForm__code">
              <Button
                className="AuthForm__codeButton"
                onClick={e => this.toggleEmailLogin(e)}
                type="button"
              >
                Login using my
                <span className="method">
                  {this.state.emailLogin ? 'setup code' : 'Tanda account'}
                </span>
              </Button>
            </div>

            <div className="AuthFormControls">
              <a
                className="AuthForm__link"
                onClick={() => {
                  statsd.increment('logIn.back');
                  hashHistory.push('/welcome');
                }}
              >
                <i className="fa fa-arrow-left" aria-hidden="true" />
                Don&#39;t have an account?
              </a>
              <Button
                className='AuthForm__button green'
                type='submit'
                disabled={this.state.sending}
              >
                <p>
                  Next
                  <i className={cn('fa', this.getButtonClass())} aria-hidden="true" />
                </p>
              </Button>
            </div>
          </form>
        </Card>
      </div>
    );
  }
}

Authenticate.propTypes = {
  next: PropTypes.func,
  authAccount: PropTypes.func,
  account: PropTypes.object,
  intl: PropTypes.object,
};

export default injectIntl(Authenticate);



// WEBPACK FOOTER //
// ./src/components/setup/authenticate/index.jsx